import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
const ActivitiesIcon = _ref => {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M12.291 11.782l2.099 19.417h3.209l3.758-16.104 1.21 2.421 1.431 0.884h8v-3.2h-7.011l-2.758-5.515h-3.031l-2.628 11.921-2.172-20.805h-3.234l-2.864 14.399h-8.301v3.2h9.6l1.566-1.27 1.126-5.347z"
  }));
};
export default /*#__PURE__*/memo(ActivitiesIcon);